export const LOCATION_PRIVACY_OPTIONS = [
  { value: "visible", label: "Show full address" },
  { value: "city_state", label: "Show city & state only" },
  { value: "hidden", label: "Hide location entirely" },
];
